import get from 'lodash/get';
import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import { Nullable } from 'modules/types/common';
import * as types from '../types';

const providerDetailInitState = {
  isFetching: false,
  provider: {} as types.ProviderDetail,
  error: null as Nullable<Error>
};

export type ProviderDetailState = typeof providerDetailInitState;

export const providerDetailsReducer = createReducer(providerDetailInitState, {
  [actions.PROVIDER_RESET_DETAIL]: () => {
    return providerDetailInitState;
  },
  [actions.PROVIDER_GET_DETAILS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.PROVIDER_GET_DETAILS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.provider = get(action, 'payload.data') || {};
  },
  [actions.PROVIDER_GET_DETAILS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  }
});

export default providerDetailsReducer;
